import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "avenue_benda_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { product_id: product.id, name: product.name, price: product.price, image_url: product.image_url, quantity: 1 }];
    });
  };
  const setQty = (product_id, quantity) => {
    if (quantity <= 0) return remove(product_id);
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity } : i));
  };
  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);
  const addMany = (lines) => {
    setItems((prev) => {
      const next = [...prev];
      for (const l of lines) {
        const idx = next.findIndex((i) => i.product_id === l.product_id);
        if (idx >= 0) next[idx] = { ...next[idx], quantity: next[idx].quantity + (l.quantity || 1) };
        else next.push({ product_id: l.product_id, name: l.name, price: l.price, image_url: l.image_url, quantity: l.quantity || 1 });
      }
      return next;
    });
  };

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, addMany, setQty, remove, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
